import React from 'react';

export default (({name}) => <p style={{margin: '20px 0'}}>Thank you for your interest in GoGuardian. 
    We are not yet operational in {name}, but will keep you updated as we plan our expansion. 
    We look forward to working with you in the future!</p>);


/** WEBPACK FOOTER **
 ** ./src/app/components/createAccount/blockedCountryWarning.jsx
 **/